"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderStatusList = void 0;
const Base_1 = require("./Base");
exports.GetOrderStatusList = {
    url: Base_1.URL_BASE + "/GetOrderStatusList",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetOrderStatusList.js.map